module.exports = __webpack_public_path__ + "6eea571add8500d2c5dd337cc2f5a23f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/Foto_Manja_Herrmann-8438.jpg
// module id = 883
// module chunks = 0